<template>
  <div id="droppalbe" class="bg ui-droppable">
    <div id="LayerOut">
      <div v-for="(cache, index) in cachetDate" :key="index">
        <div class="cacheImg" :style="{ top: cache.y, left: cache.x }">
          <img :src="cache.imgUrl" />
        </div>
      </div>
      <div id="LayerBill" style="padding-left: 10px">
        <br />
        <table width="650" border="0" cellspacing="0" cellpadding="0" align="center">
          <tbody>
            <tr>
              <td>
                <br />
                <table width="630" border="0" align="center" cellpadding="0" cellspacing="0" class="outtable">
                  <tbody>
                    <tr>
                      <td colspan="2">
                        <div align="center" style="font-size: 18px; font-weight: bold">
                          开具红字增值税专用发票通知单
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                      <td style="text-align: right; font-weight: bold">&nbsp;</td>
                    </tr>
                    <tr>
                      <td width="420">
                        填开日期：
                        <input :value="aBill.a31" name="A[0].a31" cname="a31" type="text" style="width: 120px" />
                      </td>
                      <td style="text-align: right; font-weight: bold" width="321">
                        NO.
                        <input :value="aBill.a30" name="A[0].a30" cname="a30" type="text" style="width: 150px" />
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <table width="741" border="0" cellpadding="0" cellspacing="0" class="billtable">
                          <tbody>
                            <tr>
                              <td>
                                <table width="738" border="0" cellspacing="0" cellpadding="0">
                                  <tbody>
                                    <tr>
                                      <td
                                        rowspan="2"
                                        width="49"
                                        style="border-bottom-color: #ffffff; border-left-color: #ffffff"
                                      >
                                        <div align="center">销售方</div>
                                      </td>
                                      <td width="114" height="25">
                                        <div align="center">名&nbsp;&nbsp;称</div>
                                      </td>
                                      <td width="200">
                                        <input
                                          :value="aBill.a11"
                                          name="A[0].a11"
                                          cname="a11"
                                          style="width: 190px"
                                          type="text"
                                        />
                                      </td>
                                      <td rowspan="2" width="59" style="border-bottom-color: #ffffff">
                                        <div align="center">购买方</div>
                                      </td>
                                      <td width="107">
                                        <div align="center">名&nbsp;&nbsp;称</div>
                                      </td>
                                      <td width="209">
                                        <input
                                          :value="aBill.a9"
                                          name="A[0].a9"
                                          cname="a9"
                                          style="width: 190px"
                                          type="text"
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td height="25" style="border-bottom-color: #ffffff">
                                        <div align="center">税务登记代码</div>
                                      </td>
                                      <td style="border-bottom-color: #ffffff">
                                        <input
                                          :value="aBill.a8"
                                          name="A[0].a8"
                                          cname="a8"
                                          style="width: 190px"
                                          type="text"
                                        />
                                      </td>
                                      <td style="border-bottom-color: #ffffff">
                                        <div align="center">税务登记代码</div>
                                      </td>
                                      <td style="border-bottom-color: #ffffff">
                                        <input
                                          :value="aBill.a10"
                                          name="A[0].a10"
                                          cname="a10"
                                          style="width: 190px"
                                          type="text"
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <table width="739" border="0" cellspacing="0" cellpadding="0" class="billtable1">
                                  <tbody>
                                    <tr>
                                      <td rowspan="8" width="60" style="border-left-color: #ffffff">
                                        <div align="center">
                                          开具
                                          <br />
                                          红字
                                          <br />
                                          专用
                                          <br />
                                          发票
                                          <br />
                                          内容
                                        </div>
                                      </td>
                                      <td width="118" height="25" style="border-bottom: 1px solid #000">
                                        <div align="center">货物（劳务）名称</div>
                                      </td>
                                      <td width="118" style="border-bottom: 1px solid #000">
                                        <div align="center">数量</div>
                                      </td>
                                      <td width="118" style="border-bottom: 1px solid #000">
                                        <div align="center">单价</div>
                                      </td>
                                      <td width="119" style="border-bottom: 1px solid #000">
                                        <div align="center">金额</div>
                                      </td>
                                      <td
                                        width="118"
                                        align="center"
                                        style="border-bottom: 1px solid #000; text-align: center"
                                      >
                                        税率
                                      </td>
                                      <td width="119" style="border-bottom: 1px solid #000">
                                        <div align="center">税额</div>
                                      </td>
                                    </tr>

                                    <tr v-for="(tableCells, index) of bDataList" :key="index">
                                      <td v-for="(cell, i) of tableCells" :key="i" style="height: 25px">
                                        <input
                                          :value="cell"
                                          type="text"
                                          style="text-align: right"
                                          :style="{ width: i == 5 ? '120px' : '119px' }"
                                        />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td height="25" style="border-bottom: 1px solid #000">
                                        <div align="center">合&nbsp;&nbsp;计</div>
                                      </td>
                                      <td style="border-bottom: 1px solid #000">
                                        <div align="center">-----</div>
                                      </td>
                                      <td style="border-bottom: 1px solid #000">
                                        <div align="center">-----</div>
                                      </td>
                                      <td style="border-bottom: 1px solid #000">
                                        <input
                                          :value="aBill.a20"
                                          name="A[0].a20"
                                          cname="a20"
                                          type="text"
                                          style="width: 119px; text-align: right"
                                        />
                                      </td>
                                      <td align="center" style="border-bottom: 1px solid #000">--</td>
                                      <td style="border-bottom: 1px solid #000">
                                        <input
                                          :value="aBill.a21"
                                          name="A[0].a21"
                                          cname="a21"
                                          type="text"
                                          style="width: 119px; text-align: right"
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style="border-bottom-color: #ffffff; border-left-color: #ffffff">
                                        <div align="center">说明</div>
                                      </td>
                                      <td colspan="6" style="border-bottom-color: #ffffff">
                                        一、购买方申请
                                        <input
                                          :value="aBill.a13"
                                          name="A[0].a13"
                                          cname="a13"
                                          type="checkbox"
                                          style="width: 16px"
                                          :checked="aBill.a13 == 1"
                                        />
                                        <br />
                                        对应蓝字专用发票抵扣增值税销项税额情况：
                                        <br />
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.&nbsp;&nbsp;已抵扣
                                        <input
                                          :value="aBill.a1"
                                          name="A[0].a1"
                                          cname="a1"
                                          type="checkbox"
                                          style="width: 16px"
                                          :checked="aBill.a1 == 1"
                                        />
                                        <br />
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.&nbsp;&nbsp;未抵扣
                                        <input
                                          :value="aBill.a2"
                                          name="A[0].a2"
                                          cname="a2"
                                          type="checkbox"
                                          style="width: 16px"
                                          :checked="aBill.a2 == 1"
                                        />
                                        <br />
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(1)无法认证
                                        <input
                                          :value="aBill.a14"
                                          name="A[0].a14"
                                          cname="a14"
                                          type="checkbox"
                                          style="width: 16px"
                                          :checked="aBill.a14 == 1"
                                        />
                                        <br />
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(2)纳税人识别号认证不符
                                        <input
                                          :value="aBill.a3"
                                          name="A[0].a3"
                                          cname="a3"
                                          type="checkbox"
                                          style="width: 16px"
                                          :checked="aBill.a3 == 1"
                                        />
                                        <br />
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(3)增值税专用发票代码、号码认证不符
                                        <input
                                          :value="aBill.a4"
                                          name="A[0].a4"
                                          cname="a4"
                                          type="checkbox"
                                          style="width: 16px"
                                          :checked="aBill.a4 == 1"
                                        />
                                        <br />
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(4)所购货物不属于增值税扣税项目范围
                                        <input
                                          :value="aBill.a15"
                                          name="A[0].a15"
                                          cname="a15"
                                          type="checkbox"
                                          style="width: 16px"
                                          :checked="aBill.a15 == 1"
                                        />
                                        <br />
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        对应蓝字专用发票密码区内打印的代码：
                                        <input
                                          :value="aBill.a5"
                                          name="A[0].a5"
                                          cname="a5"
                                          style="width: 150px; border-bottom: 1px solid #000000"
                                        />
                                        <br />
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号码：
                                        <input
                                          :value="aBill.a6"
                                          name="A[0].a6"
                                          cname="a6"
                                          style="width: 150px; border-bottom: 1px solid #000000"
                                        />
                                        <br />
                                        二、销售方申请
                                        <input
                                          :value="aBill.a16"
                                          name="A[0].a16"
                                          cname="a16"
                                          type="checkbox"
                                          style="width: 16px"
                                          :checked="aBill.a16 == 1"
                                        />
                                        <br />
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(1)因开票有误购买方拒收的
                                        <input
                                          :value="aBill.a24"
                                          name="A[0].a24"
                                          cname="a24"
                                          type="checkbox"
                                          style="width: 16px"
                                          :checked="aBill.a24 == 1"
                                        />
                                        <br />
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(2)因开票有误等原因尚未交付的
                                        <input
                                          :value="aBill.a25"
                                          name="A[0].a25"
                                          cname="a25"
                                          type="checkbox"
                                          style="width: 16px"
                                          :checked="aBill.a25 == 1"
                                        />
                                        <br />
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;对应蓝字专用发票密码区内打印的代码
                                        ：
                                        <input
                                          :value="aBill.a17"
                                          name="A[0].a17"
                                          cname="a17"
                                          style="width: 150px; border-bottom: 1px solid #000000"
                                        />
                                        <br />
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号码：
                                        <input
                                          :value="aBill.a18"
                                          name="A[0].a18"
                                          cname="a18"
                                          style="width: 150px; border-bottom: 1px solid #000000"
                                        />
                                        <br />
                                        <br />
                                        开具红字专用发票理由：
                                        <br />
                                        <textarea
                                          :value="aBill.a99"
                                          cols="60"
                                          rows="6"
                                          name="A[0].a99"
                                          cname="a99"
                                          wrap="hard"
                                          style="
                                            background: transparent !important;
                                            overflow: hidden;
                                            width: 700px;
                                            resize: none;
                                            height: 80px;
                                          "
                                        ></textarea>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">&nbsp;</td>
                    </tr>
                    <tr>
                      <td height="25" colspan="2">
                        经办人：
                        <input :value="aBill.a22" name="A[0].a22" cname="a22" style="width: 60px" class="line_height" />
                        负责人：
                        <input :value="aBill.a19" name="A[0].a19" cname="a19" style="width: 60px" class="line_height" />
                        主管税务机关名称（印章）：
                        <input
                          :value="aBill.a23"
                          name="A[0].a23"
                          cname="a23"
                          style="width: 210px"
                          class="line_height"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td height="25" colspan="2">
                        注：1.本通知单一式三联：第一联，申请方主管税务机关留存；第二联，申请方送交对方留存；第三联，申请方留存。
                        <br />
                        &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;2.通知单应与申请单一一对应。
                        <br />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <br />
  </div>
</template>

<script>
import { environment } from '@/utils/oss.env'
export default {
  props: {
    bgDatas: { type: Array, default: () => [] },
  },
  data() {
    return {
      aBill: [],
      cachetDate: [],
      aDataList: [],
      bDataList: [],
    }
  },
  mounted() {
    this.initABData()
  },
  methods: {
    initABData() {
      const cacheList = []
      const bDataList = []
      for (const index in this.bgDatas) {
        if (this.bgDatas[index]['a'] !== undefined) {
          this.aBill = this.bgDatas[index]['a']
        } else if (this.bgDatas[index]['c'] !== undefined) {
          const cl = this.bgDatas[index]['c']
          for (const jIndex in cl) {
            const c = cl[jIndex]
            const t = { imgUrl: '', x: '', y: '' }
            t.imgUrl = environment.cacheUrl + c.imgUrl
            t.x = c.x + 'px'
            t.y = c.y + 'px'
            cacheList.push(t)
          }
        } else if (this.bgDatas[index]['b'] !== undefined) {
          const bl = this.bgDatas[index]['b']
          for (const jIndex in bl) {
            const b = bl[jIndex]
            const t = []
            t.push(b.b1)
            t.push(b.b2)
            t.push(b.b3)
            t.push(b.b4)
            t.push(b.b6)
            t.push(b.b5)
            bDataList.push(t)
          }
        }
      }
      this.bDataList = bDataList
      this.cachetDate = cacheList
    },
  },
}
</script>

<style lang="less" scoped>
.bg {
  background: url('~@/assets/odiv_kjhrzzszzfptzs_xnsr.png');
  position: relative;
  z-index: 1;
  width: 810px;
  height: 880px;
  top: 0px;
  left: 0px;
}
#LayerOut {
  position: relative;
  top: 0;
  left: 0;
  z-index: 0;
  width: 810px;
  height: 880px;
}
#b4 {
  text-decoration: none;
  border: 0px none #cccccc;
  text-align: right;
  font-family: Verdana;
  font-size: 12px;
}
#b9 {
  text-decoration: none;
  border: 0px none #cccccc;
  text-align: right;
  font-family: Verdana;
  font-size: 12px;
}
/*标题字体颜色*/
.titlebill {
  font-family: '宋体';
  font-size: 18px;
  font-weight: bold;
  color: #000000;
  text-decoration: none;
  text-align: right;
}
/*边框*/
TABLE.thickbordertable {
  border: 1px solid #000000;
}
/*黑色表格样式*/
TABLE.billtable {
  width: 100%;
  font-family: Tahoma;
  font-size: 12px;
  color: #000000;
  white-space: nowrap;
  border-top: 1px solid #000000;
  border-left: 0px;
  border-right: 1px solid #000000;
  border-bottom: 0px;
}
.billtable TD {
  border-top: 0px;
  border-left: 1px solid #000000;
  border-right: 0px;
  border-bottom: 1px solid #000000;
}
/*C全局变量定义textarea,input,select*/
TABLE.billtable INPUT,
textarea {
  font-family: Tahoma;
  font-size: 12px;
  background: none;
  word-spacing: normal;
  width: 100%;
  border: 0px;
}
/*黑色表格样式*/
TABLE.billtable1 {
  width: 100%;
  font-family: Tahoma;
  font-size: 12px;
  color: #000000;
  white-space: nowrap;
  border-top: 0px solid #000000;
  border-left: 0px;
  border-right: 0px solid #000000;
  border-bottom: 1px solid #000000;
}
.billtable1 TD {
  border-top: 0px solid #000;
  border-left: 1px solid #000000;
  border-right: 0px;
  border-bottom: 0px solid #000000;
}
/*C全局变量定义textarea,input,select*/
TABLE.billtable1 INPUT,
textarea {
  font-family: Tahoma;
  font-size: 12px;
  background: none;
  word-spacing: normal;
  width: 100%;
  border: 0px;
}
.textarea_input {
  overflow: auto;
  font-family: Tahoma;
  font-size: 12px;
  background: none;
  word-spacing: normal;
  /*width: 100px;*/
  border: 1px none #cccccc;
}
.word_o {
  font-size: 12px;
  color: #663366;
  text-decoration: none;
}

.table_input5 {
  font-family: '宋体';
  font-size: 16px;
  font-weight: bold;
  text-align: right;
  background: none;
  color: #663366;
  word-spacing: normal;
  border: 1px none #cccccc;
}
#Layer1 {
  position: absolute;
  left: 380px;
  top: 19px;
  width: 130px;
  height: 130px;
  z-index: -1;
  background-repeat: no-repeat;
}
#Layer2 {
  position: relative;
  top: 0;
  left: 0;
  z-index: 0;
}
/*****************仿真表单表格定义样式*********************************/
TABLE.outtable {
  font-family: Tahoma;
  font-size: 12px;
  color: #000000;
}
TABLE.outtable INPUT {
  font-family: Tahoma;
  font-size: 12px;
  background: none;
  word-spacing: normal;
  /*width: 100px;*/
  border: 1px none #cccccc;
}
TABLE.outtable TD.billtitle {
  font-family: '宋体';
  font-size: 16px;
  color: #000000;
  text-decoration: none;
}
TABLE.outtable TD.simulateline_g {
  background-color: #000000;
}
.line_height {
  line-height: 18px;
}
* html .line_height {
  line-height: 15px;
}
#LayerOut {
  position: relative;
  top: 0;
  left: 0;
  z-index: 0;
  width: 790px;
  height: 880px;
}
#paperBg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 790px;
  height: 880px;
}
#LayerBill {
  position: absolute;
  top: 2px;
  left: 0;
  z-index: 2;
  width: 790px;
  height: 880px;
}
input {
  width: 98%;
}
.cacheImg {
  position: absolute;
  z-index: 1000;
  margin-top: 30px;
}
</style>
